// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"914a355f","179":"6d1230b6","413":"7ab3d171","446":"dc662a14","483":"3b11b166","488":"3f2de327","684":"adeb8c19","728":"0ffa5d15","763":"f817963c","791":"c2e7a668","948":"e8b96eca","969":"93ab0da3","979":"f64c7eb7"}[chunkId] + ".chunk.js";
};